import usePrompt from './usePrompt'

const useConfirm = (when: boolean | (() => boolean)) => {
    const blocker = usePrompt(when)

    const resetConfirmation = () => {
        if (blocker.state === 'blocked') blocker.reset()
    }

    const onConfirm = () => {
        if (blocker.state === 'blocked') blocker.proceed()
    }

    return {
        isActive: blocker.state === 'blocked',
        onConfirm,
        resetConfirmation,
    }
}

export default useConfirm
